<template>
  <div class="main">
    <product-banner class-name="productBg" :title="banner.title" :desc="banner.desc"></product-banner>

    <div class="advantage">
      <div class="advantage-container w">
        <div class="m-title">
          <h2>产品优势</h2>
        </div>
        <ul class="advantage-nav">
          <li v-for="item in advantageList" :key="item.id">
            <svg-icon :icon-class="item.svg" class-name="advantage-svg"></svg-icon>
            <h3>{{item.name}}</h3>
            <p>{{item.content}}</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="fun">
      <div class="fun-container w">
        <div class="m-title">
          <h2>主要产品功能</h2>
        </div>
        <div class="fun-content">
          <div class="fun-content-row" v-for="item in funList" :key="item.id">
            <div class="fun-info">
              <h3 class="fun-h3">{{item.name}}</h3>
              <div class="fun-desc">{{item.desc}}</div>
              <ul class="fun-list">
                <li>{{item.content}}</li>
              </ul>

              <to-try class-name="c-link" type="1"></to-try>
            </div>
            <div class="fun-pic">
              <svg-icon :icon-class="item.path" class-name="fun_svg"></svg-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <to-try class-name="c-apply" type="2"></to-try>
  </div>
</template>
<script>
export default {
  data() {
    return {
      banner: {
        title: "中医诊疗系统",
        desc: "打造互联网闭环 ，提高就诊效率"
      },
      advantageList: [
        {
          svg: "health_advantage1",
          name: "经济实惠",
          content:
            "厚科中医诊疗系统性价比高，功能完善，简单易用，满足中医馆在各发展阶段的管理需求。"
        },
        {
          svg: "health_advantage2",
          name: "提高就诊效率",
          content:
            "完善的线上预约功能，提供从预约、付费、轻问诊到医患的持续沟通等一站式服务，打通科室各诊间的互通。"
        },
        {
          svg: "health_advantage3",
          name: "增加客流",
          content: "多功能线上营销工具，打通线上营销渠道，增加中医馆客流。"
        }
      ],
      funList: [
        {
          path: "health_fun_svg1",
          name: "预约挂号",
          desc: "轻松预约，就诊效率大大提高",
          content: "预约就诊、理疗、中医美容；0元抢号、诊金立减等营销功能"
        },
        {
          path: "health_fun_svg2",
          name: "智慧营销",
          desc: "智慧营销，让营销更有价值",
          content:
            "会员RFM分级；智能会员标签；会员生日礼包；新会员感谢函；支付有礼"
        },
        {
          path: "health_fun_svg3",
          name: "微信会员",
          desc: "轻松办卡，精准营销",
          content: "线上会员卡；健康管理；储值管理"
        }
      ]
    };
  },
  methods: {
    advantageOver(index) {
      this.advantageNum = index;
    }
  }
};
</script>
<style lang='scss' scoped>
$color: #ff8e11;
/deep/ .c-link {
  background: $color;
}
/deep/ .c-apply {
  color: $color;
  background: $color;
}

/deep/ .productBg {
  background-image: url("../../assets/imgs/banner_health.png");
}
.m-title {
  h2 {
    &::after {
      content: "";
      background: $color;
    }
  }
}

.advantage {
  width: 100%;
  height: 745px;
  background: #f3f5f8;
  padding: 72px 0 0;
  .advantage-nav {
    @include clearfix;
    li {
      float: left;
      width: 382px;
      height: 460px;
      padding: 46px 60px;
      &:not(:last-child) {
        margin-right: 27px;
      }
      .advantage-svg {
        display: block;
        width: 202px;
        height: 202px;
        margin: 0 auto;
      }
      h3 {
        font-size: 22px;
        font-weight: 300;
        color: #000;
        line-height: 30px;
        text-align: center;
        margin-top: 32px;
      }
      p {
        font-size: 16px;
        font-weight: 300;
        color: #6c737d;
        line-height: 25px;
        margin-top: 22px;
      }
    }
  }
}

.fun {
  padding: 72px 0 0;
  .fun-content-row {
    padding: 0 40px 64px;
    @include clearfix;
    .fun-info {
      float: left;
      width: 434px;
      margin-top: 120px;
      .fun-h3 {
        font-size: 24px;
        font-weight: 300;
        color: #2f393f;
        line-height: 32px;
      }
      .fun-desc {
        color: #2f393f;
        font-size: 20px;
        font-weight: 300;
        line-height: 32px;
      }
      .fun-list {
        margin-top: 16px;
        li {
          font-size: 14px;
          font-weight: 400;
          color: #6c737d;
          line-height: 25px;
          margin-bottom: 12px;
        }
      }
    }
    .fun_svg {
      width: 550px;
      height: 450px;
    }
    .fun-pic {
      float: right;
    }

    &:nth-child(2n) {
      .fun-info {
        float: right;
      }
      .fun-pic {
        float: left;
      }
    }
  }
}
</style>
